export const theme = {
  switch: {
    defaultProps: {
      color: 'blue'
    }
  },
  tab: {
    styles: {
      base: {
        tab: {
          initial: {
            color: 'text-black',
            fontWeight: 'font-medium'
          }
        }
      }
    }
  },
  button: {
    defaultProps: {
      variant: 'filled',
      size: 'md',
      color: 'blue',
      fullWidth: false,
      ripple: true,
      className: ''
    },
    styles: {
      base: {
        initial: {
          textTransform: 'normal-case'
        }
      },
      sizes: {
        sm: {
          fontSize: 'text-xs',
          py: 'py-2',
          px: 'px-3.5',
          borderRadius: 'rounded-lg'
        },
        md: {
          fontSize: 'text-sm',
          py: 'py-2.5',
          px: 'px-4',
          borderRadius: 'rounded-lg'
        },
        lg: {
          fontSize: 'text-base',
          py: 'py-3',
          px: 'px-5',
          borderRadius: 'rounded-lg'
        }
      },
      variants: {
        text: {
          blue: {
            color: 'text-blue-600',
            hover: 'hover:bg-blue-600/10',
            active: 'active:bg-blue-600/30'
          }
        },
        outlined: {
          white: {
            border: 'border border-gray-300',
            color: 'text-gray-700',
            hover: 'hover:opacity-75',
            focus: 'focus:ring focus:ring-white/50',
            active: 'active:opacity-[0.85]'
          }
        },
        filled: {
          blue: {
            background: 'bg-blue-600',
            shadow: 'shadow-md shadow-blue-600/20',
            hover: 'hover:shadow-lg hover:shadow-blue-600/40',
            focus: 'focus:opacity-[0.85] focus:shadow-none',
            active: 'active:opacity-[0.85] active:shadow-none'
          }
        }
      }
    }
  },
  checkbox: {
    defaultProps: {
      color: 'blue'
    }
  },
  radio: {
    defaultProps: {
      color: 'blue'
    }
  },
  input: {
    defaultProps: {
      variant: 'outlined',
      size: 'md',
      color: 'blue',
      label: '',
      error: false,
      success: false,
      icon: undefined,
      labelProps: undefined,
      containerProps: undefined,
      shrink: false,
      className: ''
    },
    styles: {
      base: {
        container: {
          minWidth: 'min-w-[100px]'
        },
        input: {
          peer: 'peer',
          width: 'w-full',
          height: 'h-full',
          bg: 'bg-transparent',
          color: 'text-gray-500',
          fontFamily: 'font-sans',
          fontWeight: 'font-normal',
          outline: 'outline outline-0 focus:outline-0',
          disabled: 'disabled:bg-gray-200 disabled:border-0',
          transition: 'transition-all'
        }
      },
      variants: {
        outlined: {
          base: {
            input: {
              borderWidth: 'placeholder-shown:border',
              borderColor:
                'placeholder-shown:border-gray-300 placeholder-shown:border-t-gray-3 0',
              floated: {
                borderWidth: 'border focus:border-2',
                borderColor: 'border-t-transparent focus:border-t-transparent'
              }
            }
          }
        }
      }
    }
  },

  typography: {
    defaultProps: {
      variant: 'paragraph',
      color: 'text-gray-900',
      textGradient: false,
      className: ''
    },
    styles: {
      variants: {
        h1: {
          display: 'block',
          fontSmoothing: 'antialiased',
          letterSpacing: 'tracking-normal',
          fontFamily: 'font-sans',
          fontSize: 'text-4xl',
          fontWeight: 'font-semibold',
          lineHeight: 'leading-tight'
        },
        h6: {
          display: 'block',
          fontSmoothing: 'antialiased',
          letterSpacing: 'tracking-normal',
          fontFamily: 'font-sans',
          fontSize: 'text-base',
          fontWeight: 'font-semibold',
          lineHeight: 'leading-relaxed',
          color: 'text-gray-500'
        }
      }
    }
  }
}
